import React from 'react';
import classnames from 'classnames';
import {TextField as MuiTextField} from '@material-ui/core';

import styles from './TextField.scss';
import inputStyles from './Input.scss';
import mergeStyles from 'components/helpers/mergeStyles';
import ErrorIcon from '../icons/ErrorIcon';

export default function TextField({
    error,
    classes,
    inputClasses,
    InputProps,
    variant = 'outlined',
    isAutoCompleteField,
    ...restProps
}) {
    const {autoComplete, notchedOutline, placeholder, inputLabel, formControl, ...restClasses} = inputStyles;

    return (
        <MuiTextField
            variant={variant}
            error={Boolean(error)}
            helperText={error}
            classes={
                mergeStyles(
                    {
                        root: classnames(styles.root, {[styles.simpleField]: !isAutoCompleteField}),
                    },
                    classes,
                )
            }
            InputProps={{
                ...InputProps,
                disableUnderline: true,
                classes: mergeStyles(
                    {
                        ...restClasses,
                        input: classnames(inputStyles.input, {[inputStyles.autoComplete]: isAutoCompleteField}),
                        disabled: styles.disabled,
                        notchedOutline: variant === 'outlined' ? notchedOutline : undefined,
                    },
                    classes
                ),
                endAdornment: (
                    InputProps && InputProps.endAdornment
                )
            }}
            {...restProps}
        />
    );
}



// WEBPACK FOOTER //
// ./src/components/controls/fields/TextField.jsx